{
  "title": "Avions de passage et résidents – {{fboName}}",
  "search": {
    "placeholder": "Rechercher par immat., propriétaire, modèle"
  },
  "filters": {
    "showTenants": {
      "label": "Voir locataires",
      "all": "Tous les locataires",
      "unassigned": "Afficher non assignés",
      "assignedTo": "Affecté à {{locationName}}"
    },
    "currentLocation": {
      "label": "Afficher par position actuelle"
    }
  },
  "columns": {
    "tailNumber": "N° immat.",
    "ownerManager": "Propriétaire/Gérant",
    "model": "Modèle",
    "currentLocation": "Position actuelle",
    "assignedLocation": "Emplacement assigné",
    "type": "Type",
    "lastHangared": "Dernier hangarage",
    "note": "Note"
  },
  "actions": {
    "edit": "Édit."
  },
  "deleteConfirmation": {
    "title": "Voulez-vous vraiment supprimer {{identifier}} ?",
    "message": "Cet aéronef sera définitivement supprimé.",
    "confirm": "Oui"
  },
  "locationText": {
    "notHangared": "Non hangaré"
  }
}
